import addAds from "../addAdds/addAdds";

interface IResultArrayItem {
    imageUrl?: string;
    name: string;
    id: number;
    isPublic: boolean;
    isFromExplore: boolean;
}

const chunkData = (items: any[], tilesCount: number) => {
    if (items.length === 0) {
        return [];
    }
    const itemsWithAds = addAds(items);
    const chunkSize = tilesCount;
    const chunkArray = itemsWithAds?.reduce((resultArray: IResultArrayItem[][], item, index) => {
        const chunkIndex = Math.floor(index / chunkSize);
        if (!resultArray[chunkIndex]) {
            resultArray[chunkIndex] = [];
        }
        resultArray[chunkIndex].push(item);
        return resultArray;
    }, []);

    // Empty items
    if (chunkArray && chunkArray.length > 0) {
        const withContentInLastLine = chunkArray[chunkArray.length - 1].length;
        const blankTilesCount = chunkSize - withContentInLastLine;
        if (withContentInLastLine < chunkSize) {
            for (let i = 0; i < blankTilesCount; i++) {
                chunkArray[chunkArray.length - 1].push({ name: "", id: 0, isPublic: true, isFromExplore: false });
            }
        }
    }

    return chunkArray;
};

export default chunkData;
